import { Descriptions, Space, Tag, Typography } from "antd";
import {
  HANGARED_AIRCRAFT_STORAGE,
  MOORED_AIRCRAFT_STORAGE,
} from "../../../shared/constants";

const { Text } = Typography;

const AirportInformationDetails = ({ data }) => {
  const yesNo = (v) => (v === true ? "Yes" : v === false ? "No" : "-");

  const hasHangar = Array.isArray(data.aircraft_storage)
    ? data.aircraft_storage.includes(HANGARED_AIRCRAFT_STORAGE)
    : false;

  const isMoored = Array.isArray(data.aircraft_storage)
    ? data.aircraft_storage.includes(MOORED_AIRCRAFT_STORAGE)
    : false;

  const formatFeet = (n) => {
    if (n === null || n === undefined || n === "") return "-";
    const num = Number(n);
    if (Number.isNaN(num)) return "-";
    return `${num.toLocaleString("en-CA")} feet`;
  };

  return (
    <Descriptions
      bordered
      size="small"
      column={{ xs: 1, sm: 1, md: 2, lg: 3, xl: 3 }}
    >
      {/* Top row */}
      <Descriptions.Item label="Home base" span={2}>
        {data.aircraft_home_base || "-"}
      </Descriptions.Item>
      <Descriptions.Item label="Aerodrome type">
        {data.type_of_aerodrome || "-"}
      </Descriptions.Item>

      <Descriptions.Item label="Storage" span={3}>
        <Space wrap>
          {Array.isArray(data.aircraft_storage) &&
          data.aircraft_storage.length ? (
            data.aircraft_storage.map((s) => <Tag key={s}>{s}</Tag>)
          ) : (
            <Text>-</Text>
          )}
        </Space>
      </Descriptions.Item>

      {hasHangar ? (
        <>
          <Descriptions.Item label="Own hangar">
            {yesNo(data.own_hangar_checkbox)}
          </Descriptions.Item>
          <Descriptions.Item label="Same legal entity">
            {data.own_hangar_checkbox
              ? yesNo(data.same_legal_entity_checkbox)
              : "-"}
          </Descriptions.Item>
          {(data.own_hangar_checkbox === false ||
            data.same_legal_entity_checkbox === false) && (
            <Descriptions.Item label="Hangar legal entity" span={3}>
              {data.legal_entity_name || "-"}
            </Descriptions.Item>
          )}
        </>
      ) : null}

      {isMoored ? (
        <Descriptions.Item label="Mooring/yr" span={1}>
          {data.moor_duration || "-"}
        </Descriptions.Item>
      ) : null}

      <Descriptions.Item label="Own airstrip">
        {yesNo(data.own_airstrip)}
      </Descriptions.Item>
      <Descriptions.Item label="Runway surface">
        {data.runway_surface || "-"}
      </Descriptions.Item>
      <Descriptions.Item label="Runway length">
        {formatFeet(data.runway_length)}
      </Descriptions.Item>
    </Descriptions>
  );
};

export default AirportInformationDetails;
